import {FETCH_ERROR, FETCH_START, FETCH_SUCCESS, HIDE_MESSAGE, SHOW_MESSAGE, AUTHENTICATED_USER} from '../../constants/ActionTypes'
import {TOGGLE_COLLAPSED_NAV, WINDOW_WIDTH, SET_COUNTRIES_DATA, SET_CITIES_DATA, SET_SERVICE_LATERALITY_DATA, SET_RATE_TYPES_DATA} from "../../constants/ActionTypes";

const INIT_STATE = {
  error: "",
  loading: false,
  message: '',
  navCollapsed: true,
  width: window.innerWidth,
  pathname: '/',
  authUser: [],
  countries: [],
  cities: null,
  lateralities: [],
  rateTypes:[],
};

const Common = (state = INIT_STATE, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE': {
      return {
        ...state,
        pathname: action.payload.location.pathname,
        navCollapsed: false
      }
    }
    case WINDOW_WIDTH:
      return {
        ...state,
        width: action.width,
      };
    case TOGGLE_COLLAPSED_NAV: {
      return {
        ...state,
        navCollapsed: action.navCollapsed
      }
    }
    case FETCH_START: {
      return {...state, error: '', message: '', loading: true};
    }
    case FETCH_SUCCESS: {
      return {...state, error: '', message: '', loading: false};
    }
    case SHOW_MESSAGE: {
      return {...state, error: '', message: action.payload, loading: false};
    }
    case FETCH_ERROR: {
      return {...state, loading: false, error: action.payload, message: ''};
    }
    case HIDE_MESSAGE: {
      return {...state, loading: false, error: '', message: ''};
    }
    case AUTHENTICATED_USER: {
      return { ...state, authUser: action.payload }
    }
    case SET_COUNTRIES_DATA: {
      return { ...state, countries: action.payload }
    }
    case SET_CITIES_DATA: {
      return { ...state, cities: action.payload }
    }
    case SET_SERVICE_LATERALITY_DATA: {
      return { ...state, lateralities: action.payload }
    }
    case SET_RATE_TYPES_DATA: {
      return { ...state, rateTypes: action.payload }
    }
    default:
      return state;
  }
}

export default Common;
